/* eslint-disable */
// import createAuth0Client from "@auth0/auth0-spa-js";
import { ref, onMounted } from 'vue'
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { router } from "../../router";
import auth0 from "auth0-js";
import jwt_decode from "jwt-decode";
import axios from "axios";
var webAuth = new auth0.WebAuth({
  domain: process.env.VUE_APP_Auth_Domain,
  clientID: process.env.VUE_APP_Auth_Client_id,
  scope: "openid profile email offline_access",
  responseType: "token id_token",
  useRefreshTokens: true,
});

export default {
  name: "login",
  setup() {
    let loadingBlock=ref(false)
    const authResult = ref({});
    const userid = ref("");
    const router = useRouter();
    const store = useStore();
    const username = ref("");
    const password = ref("");
    const errr = ref("");
    const patientemail = ref("")
    const patientpassword = ref("")
    const resultRoleId=ref([])
    const result = ("");
    const defaultdate = ref("");
    const defaultTmile = ref("");
    var defaultStudy = ref("")
    const hasprivilege = ref(true);
    const inputType=ref("password")
		const visibleOn=ref(false)
    const errorBlock=ref(false)
    const checkRoldId=ref(false)
    const privileges = ref({
      Forms: [""],
      Schedules: [""],
      Sites: [""],
      Subjects: [""],
      Visits: ["Visit Add Visit"]
    })
    let usersettingsUrl=ref(`${process.env.VUE_APP_Service_URL}/account-core/usersettings`);
    let baseurl = ref(process.env.VUE_APP_Service_URL);
    onMounted(async () => {
      let login = document.getElementsByClassName("login-patient")[0];
      login.style.display = "none";
      let loginTabPatient = document.getElementsByClassName("patient-tab-panels")[0]
      loginTabPatient.style.backgroundColor = "#eaeaea"
    })

    async function patientloginscreen() {
      router.push(`/PatientLoginScreen`);
    }

    async function login() {

      errorBlock.value=false
      errr.value=""
      loadingBlock.value=true
      // alert(username.value + password.value);
      // return webAuth.client.login(
      //   {
      //     realm: "Username-Password-Authentication",
      //     username: username.value,
      //     password: password.value,
      //   },
      //   async function (err, authResult) {
      //     if (err) {
      //       console.log("err msg", err)
      //       console.log(err.description);
      //       if (err.description == 'Wrong email or password.') {
      //         errr.value = "Invalid username or password.";
      //       }
      //       if (err.description == "Your account has been blocked after multiple consecutive login attempts. We've sent you an email with instructions on how to unblock it.") {
      //         alert(err.description);
      //       }
      //       else if (err.description == "please change your password") {
      //         alert("Your password has been expired. Please reset your password.")
      //         router.push(`/ResetPassword/${username.value}/reset/Webapp`);
      //       }
      //     }
      //     else {
      //       console.log("authResult is");
      //       console.log(authResult);
      //       await loginAudit(authResult)
      //       await axios
      //         .put(
      //           `${baseurl.value}/management/patientschedule/visitstatusupdate`,
      //           {
      //             headers: {
      //               Authorization: "Bearer " + authResult.idToken,
      //               "Content-Type": "application/json",
      //             },
      //           })
      //         .then((res) => {
      //           console.log("statusupdate res", res);
      //         })
      //         .catch((err) => {
      //           console.log("statusupdate res", err);
      //         });
      //       await setdefaultstudy(authResult);
      //       await setuserrole(authResult);
      //       await getUserSettings(authResult)
      //       await statusUpdate();
      //     }
      //   }
      // );
      await axios
        .post(
          `${baseurl.value}/account-core/user/userauthorize`,{
           
            "userName": userid.value,
            "userEmail": username.value,
            "password": password.value
          },
        )
        .then((res) => {
             authResult.value =res.data
        })          
        .catch((err)=>{     
             
          if(err.response.data.errors){
            if (err.response.data.errors.UserName && err.response.data.errors.UserName.length !== 0) {
              errorBlock.value=true
              loadingBlock.value=false
              errr.value = "The username field is required.";
            } else if (err.response.data.errors.UserEmail && err.response.data.errors.UserEmail.length !== 0) {
              errorBlock.value=true
              errr.value = "The email field is required.";
              loadingBlock.value=false
            } else if (err.response.data.errors.Password && err.response.data.errors.Password.length !== 0) {
              errorBlock.value=true
              errr.value = "The password field is required.";
              loadingBlock.value=false
            }
          }
          else {
            if(err.response.data === "The username is not associated with this account.")
            {
              errorBlock.value=true
              errr.value = "The username is not associated with this account."
              loadingBlock.value=false
            }
            
            else if (err.response.data === "Invalid email or password."){
              errorBlock.value=true
              errr.value = "Invalid email or password."
              loadingBlock.value=false
            }
            else if(err.response.data== "Your account has been blocked after multiple consecutive login attempts. We've sent you an email with instructions on how to unblock it.")
            {
              alert("Your account has been blocked after multiple consecutive login attempts. We've sent you an email with instructions on how to unblock it.")
              loadingBlock.value=false
            }
            else if (err.response.data == "Your password has been expired. Please reset your password.") {
                      alert("Your password has been expired. Please reset your password.")
                      router.push(`/ResetPassword/${username.value}/reset/Webapp`);
                      loadingBlock.value=false
                    }
          }
          
        });
          await loginAudit(authResult.value)
          await setdefaultstudy(authResult.value)           
          await getUserSettings(authResult.value)           
          //await statusUpdate();
          errr.value=""
          await setuserrole(authResult.value);
          if (checkRoldId.value == false) {
            await router.push(`/landingPage`);
          } else {
            await checkRole(authResult.value, resultRoleId.value);
          }
          loadingBlock.value = false; 
           
        
    }
    /*Tab functionality begins */
    function loginClicked() {
      let login = document.getElementsByClassName("login")[0]
      let loginPatient = document.getElementsByClassName("login-patient")[0]
      let loginTab = document.getElementsByClassName("login-tab-panels")[0]
      let loginTabPatient = document.getElementsByClassName("patient-tab-panels")[0]
      loginTabPatient.style.backgroundColor = "#eaeaea"
      loginTab.style.backgroundColor = "#ffffff"
      loginPatient.style.display = "none"
      login.style.display = "block"
    }
    function patientLogin() {
      let login = document.getElementsByClassName("login")[0]
      let loginTab = document.getElementsByClassName("login-tab-panels")[0]
      let loginTabPatient = document.getElementsByClassName("patient-tab-panels")[0]
      let loginPatient = document.getElementsByClassName("login-patient")[0]
      loginTabPatient.style.backgroundColor = "#ffffff"
      loginTab.style.backgroundColor = "#eaeaea"
      login.style.display = "none"
      loginPatient.style.display = "block"
    }
    async function patientloginClicked() {
      const idtoken = store.getters.getIdToken;
      console.log("in funccccc")
      await axios
        .get(`${this.baseapi}verifypatientlogin?patientemail=${patientemail.value}&patientpassword=${patientpassword.value}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          })
        .then((res) => {
          console.log(res);
          this.result = res.data;
          console.log("resulttttt", this.result);
          if (this.result == true) {
            alert("Patient login success")
            this.$router.push(`/PatientDashboard`);
          }
          else {
            alert("Login failed, please check the credentials!!")
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    // async function statusUpdate() {
    //   const idtoken = store.getters.getIdToken;
    //   await axios
    //     .get(`${baseurl.value}/management/patientschedule/statusupdate`,
    //       {
    //         headers: {
    //           Authorization: "Bearer " + idtoken,
    //           "Content-Type": "application/json",
    //         },
    //       })
    //     .then((res) => {
    //       console.log(res);
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // }
    /*Tab functionality ends */
    async function checkRole(authresult,roleId) { 
      const idtoken = authresult.idToken;
      await axios
        .get(
          `${baseurl.value}/account-core/roles/getbyid?guid=${roleId[0]}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            }
          },
        )
        .then(async (res) => {
          if (res.data.role_Name == 'F4P Role') {
            await router.push(`/f4pViewer`);
          }
          else {
            await router.push(`/landingPage`);
          }
          
        })
        .catch((err) => {
          console.log(err);
        });
    }
    async function getUserSettings(authresult) {
     
      const idtoken = authresult.idToken;
      const emailId = await jwt_decode(idtoken).email;
      await axios
        .get(
          `${usersettingsUrl.value}/getbyid?userId=${emailId}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            }
          },
        )
        .then((res) => {
          if(res.data!='No data found'){
              defaultdate.value = res.data.dateFormat; 
            defaultTmile.value = res.data.timeFormat;                    
            if(defaultdate.value=="undefined" || defaultdate.value==null)
            {
              localStorage.setItem("dateformat","DD/MM/YYYY")
            }
            else{
            localStorage.setItem("dateformat",defaultdate.value)
            }

            if(defaultTmile.value=="undefined" || defaultTmile.value==null)
            {
              localStorage.setItem("timeformat","h:mm A")
            }
            else{
              localStorage.setItem("timeformat", defaultTmile.value);
            }
          }
          else{
            checkRoldId.value=true
          }
          
        })
        .catch((err) => {
          console.log(err);
        });
    }
    async function passwordVisible()
      {
        visibleOn.value=!visibleOn.value
        if(visibleOn.value==true){
          inputType.value="text"
        }
        else inputType.value="password"
      } 
    async function getrollprevilage(array, authresult) {
      const idtoken = authresult.idToken;
      // let array = (store.getters.getRolesData).split(',');
      for (const eachrole of array){
        try {
        const res = await axios.get(
          `${baseurl.value}/account-core/roles/getscreenroleprivilegebyid?guid=${eachrole}`, {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          })
          if (res.data != "No ScreenRolePrivilege found") {
             await setrolesprivileges(res.data.screens, authresult);
          } else {
            await gotopages(authresult);
          }
        } catch (err) {
          console.log(err);
        }
      }

    }
    async function setrolesprivileges(data, authresult) {
      let privilegevalues = [];
      await getStudy(localStorage.getItem("study_id_ref"),authresult);
      if(defaultStudy.isLocked !=true){
        await (data).forEach((screen) => {
          for (let j = 0; j < screen.controls.length; j++) {
            if (!privilegevalues.includes(screen.name + " " + screen.controls[j])) {
              privilegevalues.push(screen.name + " " + screen.controls[j]);
            }
          }
        });
      }
      else{
        await (data).forEach((screen) => {
          for (let j = 0; j < screen.controls.length; j++) {
            if (!privilegevalues.includes(screen.name + " " + screen.controls[j])) {
                    if(defaultStudy.lockedItems["Visits"] == true){
                      if(privileges.value.Visits.includes(screen.name + " " + screen.controls[j])){
                      }else{
                        privilegevalues.push(screen.name + " " + screen.controls[j]);
                      }
                    }
                  }
            }
        });
      }   
      let userprivilegestring = privilegevalues.join();
      await store.dispatch("setrolesprivileges", `test test,${userprivilegestring}`);
      store.dispatch("loginuser", authresult);
      // router.push("/landingpage")
      await gotopages(authresult);
    }
    async function getStudy(studyId,authresult) {
      const idtoken = authresult.idToken;
      await axios.get(`${baseurl.value}/management/study/getbyid?id=${studyId}`, {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        }
      }).then((res)=>{
          defaultStudy = res.data;
        })
        .catch(err => console.log("error while getting default study", err));
      
    }
    async function gotopages(authresult) {
      const idtoken = authresult.idToken;
      const userid = jwt_decode(idtoken).sub;
      await axios
        .get(`${baseurl.value}/account-core/settings/getdashboard?UserID=${userid}`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          store.dispatch("loginuser", authresult);
          let roles = store.getters.getRolesData;
          if (roles[0] == "bfc0a935-0441-405b-92a0-08d9af2e7771") {
              store.dispatch("setdefaultdashboard", "nursesummary");
            }
            else if(roles[0]=="f8d90da8-46d6-4265-9b24-0fc78deb4010" || roles[0]=="6c080321-2b3b-4c42-89ce-901cf0d8838e") {
              store.dispatch("setdefaultdashboard", "subjectdashboard");
            }
            else{
          if (res.data.defaultDashBoard && typeof res.data.defaultDashBoard != "undefined") {
            store.dispatch("setdefaultdashboard", res.data.defaultDashBoard);
          }
          else {
              store.dispatch("setdefaultdashboard", "home");
               
          }
        }

        })
        .catch((err) => {
          console.log(err);
          let roles = store.getters.getRolesData;
          if (roles[0] == "bfc0a935-0441-405b-92a0-08d9af2e7771") {
            store.dispatch("setdefaultdashboard", "nursesummary");
            router.push(`/nursesummary`);
          }
          else if(roles[0]="f8d90da8-46d6-4265-9b24-0fc78deb4010" || roles[0]=="6c080321-2b3b-4c42-89ce-901cf0d8838e") {
              store.dispatch("setdefaultdashboard", "subjectdashboard");
              router.push(`/subjectdashboard`);
            }
          else {
            store.dispatch("setdefaultdashboard", "home");
            router.push(`/home`);
          }
        });
    }
    async function loginAudit(authresult) {
      const token = authresult.idToken;
      const emailId = await jwt_decode(token).email;
      await axios
        .post(`${baseurl.value}/account-core/user/saveloginaudit`,
          {
            "userEmail": emailId,
            "logdetails": [
              {
                "action": "Log In",
                "date": "2022-08-30T09:10:42.634Z",
                "time": "2022-08-30T09:10:42.634Z"
              }
            ]
          }
          ,
          {
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            },
          })
        .then((res) => {
          console.log("login audit res", res)
        })
        .catch((err) => {
          console.log(err);
        });
    }

    async function setdefaultstudy(authresult) {
      await getdefaultlanguage(authresult);
      const idtoken = authresult.idToken;
      const userId = await jwt_decode(idtoken).email;
      console.log("userid " + userId);
      await axios
        .get(`${baseurl.value}/management/study/getdefaultstudy?id=` + userId, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          if (res.statusText == "No Content") {
            console.log("no default study");
          } else {
            store.dispatch("setStudyID", res.data.studyID);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    async function setuserrole(authresult) {
      const idtoken = authresult.idToken;
      const userid = (jwt_decode(idtoken).sub).trim();
      await axios
        .get(baseurl.value + "/account-core/user/getuserwithauthid?id=" + userid, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then(async (res) => {
          store.dispatch("setroles", res.data[0].role);
          resultRoleId.value=res.data[0].role
          await getrollprevilage(res.data[0].role, authresult);        
        })
        .catch((err) => {
          console.log(err);
        });
    }
    function googleLogin() {
      console.log("login with google");
      webAuth.authorize(
        {
          connection: "google-oauth2",
          redirectUri: "http://localhost:8080/home",
        },
        function (err, authResult) {
          //do something-------a
          if (err) {
            email
            console.log("err.description");
          } else {
            console.log("authResult");
            store.dispatch("loginuser", authResult);
            // router.push("/home");
          }
        }
      );
    }
    async function getdefaultlanguage(authresult) {
      // alert("default study");
      const idtoken = authresult.idToken;
      const userId = await jwt_decode(idtoken).email;
      await axios
        .get(
          // .get(`${baseurl.value}/management/study/getdefaultstudy?id=` + userId,
          `${baseurl.value}/account-core/usersettings/getbyid?userId=` + userId.trim(),
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          if (res.data.localLanguage) {
            localStorage.setItem("lang", res.data.localLanguage);
          }
          if (res.data.graphType) {
            localStorage.setItem("graphType", res.data.graphType);
          }

        })
        .catch((err) => {
          console.log(err);
        });
    }
    function testonmount() {
      store.dispatch("setrolesprivileges", 'test test,');
      store.dispatch("setNavbar", true);
    }
    function microsoftLogin() {
      console.log("login with microsof");
      webAuth.authorize(
        {
          connection: "windowslive",
          redirectUri: "http://localhost:8080/home",
        },
        function (err, authResult) {
          //do something
          if (err) {
            console.log(err.description);
          } else {
            console.log(authResult);
            store.dispatch("loginuser", authResult);
            // router.push("/home");
          }
        }
      );
    }

    onMounted(testonmount)
    return {
      login,
      authResult,
      userid,
      username,
      password,
      errr,
      defaultdate,
      defaultTmile,
      patientemail,
      patientpassword,
      result,
      usersettingsUrl,
      visibleOn,
		  inputType,
      loadingBlock,
      errorBlock,
      defaultStudy,
      privileges,
      checkRoldId,
      resultRoleId,
      setuserrole,
      googleLogin,
      microsoftLogin,
      testonmount,
      patientloginscreen,
      loginClicked,
      patientLogin,
      getdefaultlanguage,
      setdefaultstudy,
      patientloginClicked,
      passwordVisible,
      getUserSettings,
      getStudy,
      checkRole
      //statusUpdate
    };
  },
};
